import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Layout,
  Menu,
  Button,
  Dropdown,
  Avatar,
  Tooltip,
  Alert,
  Typography,
  message,
} from 'antd';
import {
  profileMenu,
  getMenuItems,
  getSecondaryItems,
  settingsTabs,
  multiWorkSpaceProfileMenu,
} from './sidenavbaroptions';
import { DownOutlined } from '@ant-design/icons';
import { setCurrentUser, setDriftState } from '../auth/authActions';
import queryString from 'query-string';
import { logout } from '../auth/authActions';
import {
  checkSlackLink,
  getAssisantSkills,
  getWorkspaceMembers,
  getChannelList,
  recentCheckins,
  getRecentTeamsyncs,
  resetChannelsList,
} from '../skills/skills_action';
import {
  getUserWorkspaces,
  getWorkspace,
  getTrooprBotUser,
} from '../common/common_action';
import { getStatuses } from '../project/tasks/section/sectionActions';
import { getTasks, getBacklogTasks } from '../project/tasks/task/taskActions';
import { getUsersSelectedTeamSync } from '../skills/skills_action';
import FeedbackModal from './feedbackmodal';
import axios from 'axios';
import './sidebar-new.css';
import { sendMessageOnchat } from '../../utils/utils';

const { Sider } = Layout;
const { Text } = Typography;

let finalRecentProject = [];

class sidenavbar2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: '1',
      visible: false,
      collapsed: false,
      newProjectModal: false,
      createProjectLoading: false,
      projectName: '',
      wId: '',
      userWorkspacesLoading: true,
      newStandupModalVisible: false,
      isSlackConnected: false,
      teamSyncs: [],
      currentMenuItem: [],
      currentSubmenuItem: [],
      currentSecondSidebarMenuItem: [],
      showCalender: false,
      feedback_modal_visible: false,
      jiraSkill: false,
      checkinSkillDisabled: false,
      projectDisabled: false,
      helpdeskDisabled: false,
      reportsDisabled: false,
      wikiSkillDisabled: false,
      mainSidebarClollapsed: false,
      sidebarVisible: true,
      secondSideBarStyle:
        localStorage.getItem('theme') === 'default'
          ? {
              background: '#f5f7fa',
              borderRight: '1px solid #e5e5e5',
              height: '100vh',
              paddingBottom: 185,
            }
          : { height: '100vh', paddingBottom: 185 },
    };
  }

  _getInitials(name) {
    if (!name) return '';

    let nameArr = name
      .trim()
      .replace(/\s+/g, ' ') //remove extra spaces
      .split(' ');

    if (nameArr.length > 1)
      return (nameArr[0][0] + nameArr[1][0]).toUpperCase();
    else return nameArr[0].slice(0, 2).toUpperCase();
  }

  switchView = (e) => {
    const { skills } = this.props;
    const wikiSkill = skills.find((skill) => skill.key === 'wiki');
    const jiraSkill = skills.find((skill) => skill.key === 'jira');
    let key = e.key ? e.key : e;
    let wId = this.props.match.params.wId;
    let { pathname } = this.props.location;
    let pathArr = pathname.split('/');
    let sub_skill = e.keyPath[1];

    if (key === 'my-checkins') {
      this.props.history.push(`/${wId}/teamsyncs`);
    } else if (key === 'squads') {
      this.props.history.push(`/${wId}/squads`);
    } else if (key && key.length > 0 && key.startsWith('ts')) {
      const tab = key.split(':')[1];
      this.showreport(key.split('ts')[1], tab);
    } else if (key === 'settings') {
      this.props.history.push(`/${wId}/settings?view=profile`);
    } else if (key === 'help') {
      localStorage.setItem('TROOPR_DRIFT_APP_MESSAGE', '👋');
      this.openChatWindow('👋');
    } else if (key === 'logout') {
      this.logoutFromApp();
    } else if (key && key.length > 0 && key.startsWith('sqd')) {
      const tab = key.split(':')[1];
      this.getProject(key.split('sqd')[1], tab);
    } else if (key === 'newStandup') {
      this.toggleNewStandupModal();
      return;
    } else if (key === 'newsquad') return;
    else if (key === 'dashboard') {
      this.props.history.push(`/${wId}/dashboard`);
    } else if (key === 'metrics') {
      this.props.history.push(`/${wId}/metrics`);
    } else if (
      (key && key.length > 0 && key.startsWith('Jira')) ||
      key.startsWith('jira')
    ) {
      if (sub_skill) {
        const id = this.state.jiraSkill._id;
        const tab = key.split(':')[1];
        let link = `/${wId}/skills/${id}/${sub_skill}`;
        if (tab) link += `?view=${tab}`;
        this.props.history.push(link);
      } else {
        const tab = key.split(':')[1];
        this.goToSkill(key.split('Jira')[1], tab);
      }
    } else if (key && key.length > 0 && key.startsWith('GitHub')) {
      const tab = key.split(':')[1];
      this.goToSkill(key.split('GitHub')[1], tab);
    } else if (key && key.length > 0 && key.startsWith('wiki')) {
      const tab = key.split(':')[1];
      this.goToSkill(key.split('wiki')[1], tab);
    } else if (key === 'upgrade') {
      this.props.history.push(`/${wId}/settings?view=upgrade`);
    } else if (key === 'all_checkins') {
      this.props.history.push(`/${wId}/teamsyncs/all`);
    } else if (key === 'templates') {
      this.props.history.push(`/${wId}/teamsyncs/templates`);
    } else if (key === 'global_insights') {
      this.props.history.push(`/${wId}/teamsyncs/global_insights`);
    } else if (key === 'global-insights') {
      this.props.history.push(`/${wId}/global-insights`);
    } else if (key === 'planned_absences') {
      this.props.history.push(`/${wId}/${key}`);
    } else if (key === 'globalholidays') {
      this.props.history.push(`/${wId}/globalholidays`);
    } else if (key === 'mynotifications') {
      this.props.history.push(`/${wId}/settings?view=notifications`);
    } else if (key === 'labels') {
      this.props.history.push(`/${wId}/labels`);
    } else if (settingsTabs.includes(key)) {
      this.props.history.push(`/${wId}/settings?view=${key}`);
    } else if (key === 'appHome') {
      this.props.history.push(`/${wId}/appHome`);
    } else if (key === 'getting_started') {
      this.props.history.push(`/${wId}/getting_started`);
    } else if (key === 'feedback_submit') {
      this.toggleFeedbackModal();
    } else if (key === 'home') this.goHome();
    else if (key === 'teamsync_integrations')
      this.props.history.push(
        `/${wId}/teamsyncs/integrations/${jiraSkill.skill_metadata._id}`
      );
    else if (key === 'Slack redirect') {
      if (this.props.team && this.props.team.id) {
        const team_id = this.props.team.id;
        const app = process.env.REACT_APP_TROOPR_APP_ID;
        let slackurl = `https://slack.com/app_redirect?app=${app}&team=${team_id}&tab=home`;
        window.open(slackurl, '_blank');
      }
    }
  };

  goToSkill = (data, tab) => {
    const skill_id = data ? data.split(':')[0] : [];

    if (!tab || tab === 'connection')
      this.props.history.push(
        `/${this.state.wId}/skills/${skill_id}?view=connection`
      );
    else if (tab)
      this.props.history.push(
        `/${this.state.wId}/skills/${skill_id}?view=${tab}`
      );
  };

  componentDidMount() {
    const { workspace, skills } = this.props;
    const { currentSubmenuItem } = this.state;
    if (skills.length > 0) {
      this.checkSkillDisabled();
    }

    this.setState({ userWorkspacesLoading: true });
    this.props.getUserWorkspaces().then(() => {
      this.setState({ userWorkspacesLoading: false });
    });

    let wId = this.props.match.params.wId;
    if (wId) {
      this.updateViewStates();
      this.setState({
        wId,
        isSlackConnected: this.props.workspace.isSlack,
      });
      // this.props.checkSlackLink(wId);
      // this.props.getWorkspaceMembers(wId).then((res) => {});

      this.props.getAssisantSkills(wId).then((res) => {
        if (res && res.data && res.data.success) {
        }
      });

      if (
        currentSubmenuItem[0] &&
        currentSubmenuItem[0].length > 0 &&
        currentSubmenuItem[0].startsWith('ts')
      ) {
        let tId = currentSubmenuItem[0].split('ts')[1];
        this.props.recentCheckins(tId, wId);
      } else {
        this.props.getRecentTeamsyncs(wId);
      }
    }

    let parsed_query = queryString.parse(this.props.location.search);
    if (parsed_query && parsed_query.botupdate) {
      message.success(
        'Troopr Assistant successfully updated to latest version!'
      );
      this.props.history.push(`/${this.props.match.params.wId}/dashboard`);
    } else if (
      parsed_query &&
      parsed_query.source &&
      parsed_query.source === 'appsumo_update'
    ) {
      message.success('AppSumo code successfully redeemed!', 5);
      this.props.history.push(`/${this.props.match.params.wId}/dashboard`);
    } else if (
      parsed_query &&
      parsed_query.source &&
      parsed_query.source === 'workspace_already_paid'
    ) {
      message.error('Workspace is already paid in troopr', 10);
      this.props.history.push(`/${this.props.match.params.wId}/dashboard`);
    } else if (parsed_query.source === 'product_already_subscribed') {
      let product;
      if (parsed_query.product === 'standups') product = 'Check-ins';
      else if (parsed_query.product === 'jira_software')
        product = 'Projects (Jira)';
      else if (parsed_query.product === 'jira_service_desk')
        product = 'HelpDesk (Jira)';
      else if (parsed_query.product === 'wiki') product = 'Wiki (Confluence)';
      else if (parsed_query.product === 'jira_reports')
        product = 'Reports (Jira)';
      message.error(
        `Oops! You have already subscribed to ${product}. You can try with another product`,
        10
      );
      this.props.history.push(`/${this.props.match.params.wId}/dashboard`);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { userTeamSync, workspace, skills } = this.props;
    let wID = localStorage.getItem('userCurrentWorkspaceId');

    if (skills !== prevProps.skills) {
      this.checkSkillDisabled();
    }

    if (wID && this.state.wId !== wID) {
      let userId = localStorage.getItem('trooprUserId');
      this.props.checkSlackLink(wID);
      // this.props.getWorkspaceMembers(wID).then((res) => {});

      this.setState({ wId: wID });
      this.props.getAssisantSkills(wID).then((res) => {});
      this.props.getTrooprBotUser(wID);
    }

    if (prevProps.userTeamSync != userTeamSync) {
      const selectedMem = userTeamSync.selectedMembers.map((mem) => mem._id);
      if (
        !selectedMem.includes(this.props.user_now._id) &&
        userTeamSync.user_id._id !== this.props.user_now._id
      )
        this.setState({ showCalender: false });
      else this.setState({ showCalender: true });
    }

    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.updateViewStates();
    }

    if (this.props.skills !== prevProps.skills) this.updateViewStates();
    if (this.props.location.search !== prevProps.location.search) {
      this.updateViewStates();
      let query = queryString.parse(this.props.location.search);
      if (query.theme) {
        // TO UPDATE SECOND SIDEBAR STYLE WHEN THEME IS CHANGED
        this.setState({
          secondSideBarStyle:
            query.theme === 'default'
              ? {
                  background: '#f5f7fa',
                  borderRight: '1px solid #e5e5e5',
                  height: '100vh',
                  paddingBottom: 185,
                }
              : { height: '100vh', paddingBottom: 185 },
        });
      }
    }
  }

  checkSkillDisabled = () => {
    const { skills } = this.props;
    const checkinSkill = skills.find((skill) => skill.key === 'standups');
    const wikiSkill = skills.find((skill) => skill.key === 'wiki');
    const jiraSkill = skills.find((skill) => skill.key === 'jira');
    const jiraProject = jiraSkill.skill_metadata.sub_skills.find(
      (sub) => sub.key === 'jira_software'
    );
    const jiraReport = jiraSkill.skill_metadata.sub_skills.find(
      (sub) => sub.key === 'jira_reports'
    );
    const jiraHelpdesk = jiraSkill.skill_metadata.sub_skills.find(
      (sub) => sub.key === 'jira_service_desk'
    );

    this.setState({
      jiraSkill: jiraSkill.skill_metadata,
      checkinSkillDisabled: checkinSkill.skill_metadata.disabled,
      projectDisabled: jiraProject.disabled,
      reportsDisabled: jiraReport.disabled,
      helpdeskDisabled: jiraHelpdesk && jiraHelpdesk.disabled,
      wikiSkillDisabled:
        wikiSkill &&
        wikiSkill.skill_metadata &&
        wikiSkill.skill_metadata.disabled,
    });
  };

  onWSSwitcherMenu = ({ key }) => {
    let wId = key;
    localStorage.setItem('userCurrentWorkspaceId', wId);
    axios.interceptors.request.use((config) => {
      config.headers['wId'] = wId;
      return config;
    });

    this.props.getWorkspace(wId).then((res) => {
      if (res && res.data && res.data.success) {
        this.props.history.push('/' + wId + '/dashboard');
      }
    });

    this.props.resetChannelsList();
    this.props.getRecentTeamsyncs(wId);
  };

  recentSquads = () => {
    let recPro = [];
    this.props.recentPro.forEach((project) => {
      if (project.workspace_id._id == this.state.wId) {
        recPro.push(project);
      }
    });
    finalRecentProject = recPro;
  };

  submenu = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };
  // sendtoslack = () => {

  //   const app = localStorage.getItem('app');
  //   let teamId = localStorage.getItem("teamId");

  //   let url = (app && teamId)? `https://slack.com/app_redirect?app=${app}&team=${teamId}`:`https://slack.com`
  //   window.open(url, `_blank`);
  //   window.location.href = url;

  // }

  logoutFromApp = () => {
    const { team } = this.props;
    this.props.logout();
    let link = '/troopr/access';
    if (team && team.app_id && team.app_id === 'A03UG41QG6T')
      link += '?app=helpdesk';
    window.location.href = link;
  };

  openChatWindow = (msg) => {
    sendMessageOnchat(msg);
  };

  openNewProjectModal = () => {
    this.setState({
      newProjectModal: !this.state.newProjectModal,
      projectName: '',
    });
  };
  closeModal = () => {
    this.setState({ newProjectModal: false });
  };
  getProject = (data, tab) => {
    const pId = data.split(':')[0];
    let project = this.props.projects.find((p) => p._id === pId);
    this.props.getStatuses(this.state.wId, project._id);
    this.props.getTasks(this.state.wId, project._id);
    this.props.getBacklogTasks(this.state.wId, project._id);

    this.props.setProject(project);

    if (!tab || tab === 'active')
      this.props.history.push(`/${this.state.wId}/squad/${pId}/tasks`);
    else if (tab)
      this.props.history.push(
        `/${this.state.wId}/squad/${pId}/tasks?view=${tab}`
      );
  };

  showreport = (data, tab) => {
    const tsId = data.split(':')[0];

    if (!tab || tab === 'report')
      this.props.history.push(`/${this.state.wId}/teamsync/${tsId}`);
    else if (tab)
      this.props.history.push(`/${this.state.wId}/teamsync/${tsId}/${tab}`);
  };

  goToSlackAppHome = () => {
    let url = `https://slack.com/app_redirect?app=AE4FF42BA&team=${this.props.assistant.id}&tab=home`;
    window.open(url);
    this.setState({ newStandupModalVisible: false });
  };

  toggleNewStandupModal = () => {
    this.setState(
      { newStandupModalVisible: !this.state.newStandupModalVisible },
      () => {
        !this.state.newStandupModalVisible &&
          setTimeout(() => this.clickChild(), 500);
      }
    );
  };

  handleSecondSidebarClick = ({ key }) => {
    const wId = this.props.match.params.wId;
    if (!key) return;

    if (key === 'emoji_actions' || key === 'commands' || key === 'slackApp')
      this.props.history.push(`/${wId}/${key}`);
    else if (key === 'personal_emoji_actions')
      this.props.history.push(`/${wId}/emoji_actions?scope=personal`);
    else if (
      key === 'workspace' ||
      key === 'profile' ||
      key === 'product' ||
      key === 'admin' ||
      key === 'members' ||
      key === 'upgrade'
    ) {
      this.props.history.push(`/${wId}/settings?view=${key}`);
    } else if (key === 'personalapphome') {
      this.props.history.push(`/${wId}/settings/personalapphome`);
    }
  };
  updateViewStates = () => {
    let { search, pathname } = this.props.location;
    let pathArr = pathname.split('/');
    let query = queryString.parse(search);
    let resource = pathArr[2];
    const checkIsPersonalApphome =
      pathArr[3] && pathArr[3] === 'personalapphome' ? true : false;
    let sub_skill = pathArr[4];
    let currentMenuItem = [];
    let currentSubmenuItem = [];
    let currentSecondSidebarMenuItem = [];
    if (resource === 'squad') {
      currentSubmenuItem = ['sqd' + pathArr[3]];
    } else if (resource === 'teamsync') {
      currentMenuItem = ['teamsyncs'];
      currentSubmenuItem = ['ts' + pathArr[3]];
    } else if (resource === 'skills') {
      if (this.props.skills) {
        let skill = this.props.skills.find((s) => {
          let id = s.skill_metadata ? s.skill_metadata._id : '';
          return id === pathArr[3];
        });
        if (sub_skill) {
          currentMenuItem = [sub_skill];
          currentSubmenuItem = [currentSubmenuItem + sub_skill + pathArr[3]];
          currentSubmenuItem = [
            currentSubmenuItem +
              (query.view ? `:${query.view}` : ':connection'),
          ];
        } else if (skill && skill.key === 'wiki') {
          currentMenuItem = ['wiki'];
          currentSubmenuItem = [skill ? skill.key + pathArr[3] : ''];
          currentSubmenuItem = [
            currentSubmenuItem +
              (query.view ? `:${query.view}` : ':connection'),
          ];
        }
      }
    } else if (resource === 'teamsyncs') {
      currentSubmenuItem = [
        pathArr[3] === 'integrations'
          ? 'teamsync_integrations'
          : pathArr[2] === 'teamsyncs'
          ? 'my-checkins'
          : resource,
      ];
      currentMenuItem = ['teamsyncs'];
    } else if (
      resource === 'global-insights' ||
      resource === 'planned_absences' ||
      resource === 'globalholidays'
    ) {
      currentSubmenuItem = [resource];
      currentMenuItem = ['teamsyncs'];
    } else if (
      resource === 'dashboard' ||
      resource === 'getting_started' ||
      resource === 'metrics'
    ) {
      currentSubmenuItem = [resource];
      currentMenuItem = ['home'];
    } else if (resource === 'settings') {
      currentSubmenuItem = [resource];
      if (query && query.view && !checkIsPersonalApphome) {
        if (
          query.view === 'profile' ||
          query.view === 'workspace' ||
          query.view === 'product' ||
          query.view === 'admin' ||
          query.view === 'members' ||
          query.view === 'upgrade'
        )
          currentSecondSidebarMenuItem = [query.view];
      } else {
        if (checkIsPersonalApphome) {
          currentSecondSidebarMenuItem = ['personalapphome'];
        } else {
          currentSecondSidebarMenuItem = ['profile'];
        }
      }
    } else if (resource === 'emoji_actions' && query && query.scope) {
      currentSubmenuItem = ['settings'];
      currentSecondSidebarMenuItem = ['personal_emoji_actions'];
    } else if (
      resource === 'emoji_actions' ||
      resource === 'slackApp' ||
      resource === 'commands'
    ) {
      currentSubmenuItem = ['settings'];
      currentSecondSidebarMenuItem = [resource];
    }
    this.setState({
      currentMenuItem,
      currentSubmenuItem,
      currentSecondSidebarMenuItem,
    });
  };

  checkFeaturesVisible = (feature) => {
    const { workspace } = this.props;
    if (feature === 'squads') {
      if (workspace && 'showSquads' in workspace) {
        return workspace.showSquads;
      } else if (workspace) {
        return true;
      }
    } else {
      if (workspace && 'showGithub' in workspace) {
        return workspace.showGithub;
      } else if (workspace) {
        return true;
      }
    }
  };

  gotoBilling = () =>
    this.props.history.push(
      `/${this.props.match.params.wId}/settings?view=upgrade`
    );

  getProfileMenu = () => {
    const { assistant_skills } = this.props;
    return (
      <Menu
        onClick={({ item, key, keyPath, domEvent }) => {
          domEvent.preventDefault();
          domEvent.stopPropagation();
          this.switchView({ item, key, keyPath, domEvent });
        }}
      >
        {profileMenu({ assistant_skills })}
      </Menu>
    );
  };
  getMultiWorkSpaceMenu = (data, getId) => {
    const { assistant_skills } = this.props;

    const workspace = data;
    const id = getId;
    const switcherFunc = this.onWSSwitcherMenu;
    return (
      <Menu
        onClick={({ item, key, keyPath, domEvent }) => {
          domEvent.preventDefault();
          domEvent.stopPropagation();
          this.switchView({ item, key, keyPath, domEvent });
        }}
        style={{ width: '200px' }}
      >
        {multiWorkSpaceProfileMenu(
          { assistant_skills },
          workspace,
          id,
          switcherFunc
        )}
      </Menu>
    );
  };

  toggleSubMenu = (e, sub_skill, skill) => {
    if (e && e.key) {
      if (sub_skill && skill) {
        this.props.history.push(
          `/${this.props.match.params.wId}/skills/${skill.skill_metadata._id}/${sub_skill.key}?view=connection`
        );
      } else if (e.key == 'teamsyncs') {
        this.props.history.push(`/${this.props.match.params.wId}/teamsyncs`);
      } else if (e.key === 'jira') {
        if (this.props.skills) {
          let jiraSkill = this.props.skills.filter(
            (skill) => skill && skill.name === 'Jira'
          );
          if (jiraSkill && jiraSkill[0].skill_metadata) {
            this.props.history.push(
              `/${this.props.match.params.wId}/skills/${jiraSkill[0].skill_metadata._id}?view=connection`
            );
          }
        }
      } else if (e.key == 'github') {
        if (this.props.skills) {
          let githubSkill = this.props.skills.filter(
            (skill) => skill && skill.name === 'GitHub'
          );
          if (githubSkill && githubSkill[0].skill_metadata) {
            this.props.history.push(
              `/${this.props.match.params.wId}/skills/${githubSkill[0].skill_metadata._id}?view=connection`
            );
          }
        }
      } else if (e.key == 'wiki') {
        if (this.props.skills) {
          let wikiSkill = this.props.skills.filter(
            (skill) => skill && skill.key === 'wiki'
          );
          if (wikiSkill && wikiSkill[0].skill_metadata) {
            this.props.history.push(
              `/${this.props.match.params.wId}/skills/${wikiSkill[0].skill_metadata._id}?view=connection`
            );
          }
        }
      } else if (e.key == 'squads') {
        this.props.history.push(`/${this.props.match.params.wId}/squads`);
      } else if (e.key == 'home') {
        this.props.history.push(`/${this.props.match.params.wId}/dashboard`);
      }
    }
  };

  getMenuItems = () => {
    const { currentMenuItem, showCalender } = this.state;
    const { isWorkspaceAdmin } = this.props;
    const {
      userTeamSync,
      workspace,
      skills,
      recentPro,
      projects,
      project,
      teamSyncs,
      user_now,
      currentSkill,

      team,
      recentTeamsyncs,
    } = this.props;
    const jiraSkill = skills.find((skill) => skill.name === 'Jira');
    const path = this.props.location.pathname.split('/')[3];
    const parsedQueryString = queryString.parse(window.location.search);
    const checkFeaturesVisible = (data) => this.checkFeaturesVisible(data);
    const recentSquads = () => this.recentSquads();
    const openNewProjectModal = () => this.openNewProjectModal();
    const toggleSubMenu = (e, sub_skill, skill) =>
      this.toggleSubMenu(e, sub_skill, skill);

    // return <GetMenuItems
    // currentMenuItem = {currentMenuItem}
    //   userTeamSync = {userTeamSync}
    //   finalRecentProject = {finalRecentProject}
    //   workspace = {workspace}
    //   skills = {skills}
    //   recentPro = {recentPro}
    //   path = {path}
    //   projects = {projects}
    //   checkFeaturesVisible = {checkFeaturesVisible}
    //   teamSyncs = {teamSyncs}
    //   user_now = {user_now}
    //   showCalender = {showCalender}
    //   recentSquads = {recentSquads}
    //   isAdmin={ isWorkspaceAdmin}
    //   project = {project}
    //   openNewProjectModal = {openNewProjectModal}
    //   currentSkill = {currentSkill}
    //   parsedQueryString = {parsedQueryString}
    //   members = {members}
    //   jiraSkill = {jiraSkill}
    //   toggleSubMenu = {toggleSubMenu}
    //   recentTeamsyncs= {recentTeamsyncs}
    //   team = {team}
    // />

    return getMenuItems({
      currentMenuItem,
      userTeamSync,
      finalRecentProject,
      workspace,
      skills,
      recentPro,
      path,
      projects,
      checkFeaturesVisible,
      teamSyncs,
      user_now,
      showCalender,
      recentSquads,
      isAdmin: isWorkspaceAdmin,
      project,
      openNewProjectModal,
      currentSkill,
      parsedQueryString,

      jiraSkill,
      toggleSubMenu,
      recentTeamsyncs,
      team,
    });
  };

  getSecondaryItems = () => {
    const { currentMenuItem, showCalender, currentSubmenuItem } = this.state;
    const {
      userTeamSync,
      workspace,
      skills,
      recentPro,
      projects,
      project,
      teamSyncs,
      user_now,
      currentSkill,

      team,
      recentTeamsyncs,
      isWorkspaceAdmin,
    } = this.props;
    const path = this.props.location.pathname.split('/')[3];
    const parsedQueryString = queryString.parse(window.location.search);
    const checkFeaturesVisible = (data) => this.checkFeaturesVisible(data);
    const recentSquads = () => this.recentSquads();
    const openNewProjectModal = () => this.openNewProjectModal();

    return getSecondaryItems({
      currentMenuItem,
      userTeamSync,
      finalRecentProject,
      workspace,
      skills,
      recentPro,
      path,
      projects,
      checkFeaturesVisible,
      teamSyncs,
      user_now,
      showCalender,
      recentSquads,
      isAdmin: isWorkspaceAdmin,
      project,
      openNewProjectModal,
      currentSkill,
      parsedQueryString,

      recentTeamsyncs,
      team,
      currentSubmenuItem,
    });
  };

  toggleFeedbackModal = () => {
    this.setState({
      feedback_modal_visible: !this.state.feedback_modal_visible,
    });
  };

  helperFunction = () => {
    let userName = '';

    if (this.props.user_now._id && this.props.botuser._id) {
      userName =
        this.props.botuser.displayName ||
        this.props.botuser.name ||
        this.props.user_now.displayName ||
        this.props.user_now.name;
    } else userName = '';
    let workspaceName = this.props.workspace.name;
    workspaceName =
      workspaceName.length > 24
        ? `${workspaceName.slice(0, 21)}...`
        : workspaceName;
    userName =
      userName && userName.length > 24
        ? `${userName.slice(0, 21)}...`
        : userName;

    return (
      <a className='upper-menubar'>
        <Avatar
          className='sidenavbar_avatars'
          style={{
            marginRight: 8,
            marginTop: 0,
            backgroundColor: 'rgba(204,204,204, 0.8)',
          }}
          src={this.props.botuser.profilePicUrl}
        >
          {this._getInitials(userName)}
        </Avatar>
        {!this.state.mainSidebarClollapsed && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              marginRight: 8,
            }}
          >
            <div
              style={{
                color: 'white',
                lineHeight: '20px',
              }}
            >
              {workspaceName}
            </div>
            <div
              style={{
                color: '#999',
                fontSize: 10,
                lineHeight: '12px',
              }}
            >
              {userName}
            </div>
          </div>
        )}
        <DownOutlined style={{ fontSize: 10, color: 'white' }} />
      </a>
    );
  };
  multiWorkSpaceUpperMenuBar = (workspace, wId) => {
    return (
      <Tooltip title={this.props.workspace.name} placement='right'>
        <Dropdown
          overlay={this.getMultiWorkSpaceMenu(workspace, wId)}
          trigger={['click']}
        >
          {this.helperFunction()}
        </Dropdown>
      </Tooltip>
    );
  };
  upperMenuBar = () => {
    return (
      <Tooltip title={this.props.workspace.name} placement='right'>
        <Dropdown overlay={this.getProfileMenu()} trigger={['click']}>
          {this.helperFunction()}
        </Dropdown>
      </Tooltip>
    );
  };

  updateBot = () => {
    window.open('https://app.troopr.io/slack?source=botupdate', '_self');
  };

  updateBotBanner = () => {
    return (
      <Alert
        style={{
          width: '100vw',
          minHeight: '40px',
          maxHeight: '40px',
          zIndex: '10000',
          position: 'absolute',
        }}
        message={
          <span>
            It appears that you may have an older version of Troopr installed.
            It is recommended that you update to the latest version to take full
            advantage of Troopr's capabilities.{' '}
            <Button
              onClick={() => this.updateBot()}
              type='primary'
              size='small'
            >
              Update Troopr
            </Button>{' '}
          </span>
        }
        banner
        closable
      />
    );
  };

  render() {
    const { team, isWorkspaceAdmin } = this.props;
    const {
      currentMenuItem,
      currentSubmenuItem,
      currentSecondSidebarMenuItem,
    } = this.state;
    let wId = this.props.match.params.wId;

    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      let comparison = 0;
      if (nameA > nameB) {
        comparison = 1;
      } else if (nameA < nameB) {
        comparison = -1;
      }
      return comparison;
    }
    const isMultiWorkspace = this.props.userWorkspaces
      ? this.props.userWorkspaces.length > 1
      : false;
    let workspaces = isMultiWorkspace
      ? this.props.userWorkspaces.sort(compare)
      : this.props.userWorkspaces;
    const user_data = this.props.userMembership;

    // members &&
    // members.find((mem) => mem.user_id && mem.user_id._id === user_now._id);
    if (user_data && user_data.user_id)
      this.props.user_now.displayName = user_data.user_id.displayName || '';

    const botScopesArr =
      team && team.bot && team.bot.scope ? team.bot.scope.split(',') : [];
    let old_bot = false;
    if (team && team.old_bot) old_bot = true;
    return (
      <>
        {old_bot && isWorkspaceAdmin && this.updateBotBanner()}
        <Fragment>
          <Sider
            width={230}
            breakpoint='lg'
            collapsedWidth='0'
            onCollapse={(collapsed, type) => {
              if (collapsed === false) {
                this.setState({ sidebarVisible: true });
              } else this.setState({ sidebarVisible: false });
            }}
          >
            <Menu
              className=' submenu_class dashboard'
              theme={'dark'}
              mode='inline'
              selectedKeys={currentSubmenuItem || []}
              openKeys={currentMenuItem || []}
              onClick={this.switchView}
              style={{ height: '100vh' }}
              expandIcon={<></>}
              onCollapse={(collapsed, type) => {
                this.setState({
                  mainSidebarClollapsed: !this.state.mainSidebarClollapsed,
                });
              }}
            >
              {isMultiWorkspace
                ? this.multiWorkSpaceUpperMenuBar(workspaces, wId)
                : this.upperMenuBar()}
              {this.state.sidebarVisible ? this.getMenuItems() : ''}
            </Menu>
          </Sider>
          {currentSubmenuItem[0] &&
            ['settings', 'emoji_actions', 'commands', 'slackApp'].includes(
              currentSubmenuItem[0]
            ) && (
              <Sider
                width={220}
                // breakpoint='lg'
                // collapsedWidth='0'
                // onBreakpoint={broken => {
                // }}
              >
                <Menu
                  // className=' submenu_class dashboard'
                  mode='inline'
                  selectedKeys={currentSecondSidebarMenuItem}
                  onClick={this.handleSecondSidebarClick}
                  style={this.state.secondSideBarStyle}
                >
                  <>
                    <div style={{ height: 64, padding: '20px 0 20px 12px' }}>
                      <Text style={{ lineHeight: '24px' }} strong>
                        Settings
                      </Text>
                    </div>

                    {this.getSecondaryItems()}
                  </>
                </Menu>
              </Sider>
            )}
          <FeedbackModal
            feedback_modal_visible={this.state.feedback_modal_visible}
            toggleFeedbackModal={this.toggleFeedbackModal}
          />

          {/* {this.state.newProjectModal ? <SquadCreationModal newProjectModal={this.state.newProjectModal} closeModal={this.closeModal} /> : ""} */}

          {/* <CreateTeamsyncModal
          newStandupModalVisible={this.state.newStandupModalVisible}
          modalToggle={this.toggleNewStandupModal}
          // https://stackoverflow.com/questions/37949981/call-child-method-from-parent
          setClick={(click) => (this.clickChild = click)}

          //whenever you add something here check in allstandups,standupReport,dashboard files too
        /> */}
        </Fragment>
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    workspace: store.common_reducer.workspace,
    user_now: store.common_reducer.user,
    assistant: store.skills.team,
    skills: store.skills.skills,
    teamSyncs: store.skills.userTeamSyncs,
    userWorkspaces: store.common_reducer.userWorkspaces,
    userTeamSync: store.skills.userTeamSync,
    currentSkill: store.skills.currentSkill,

    assistant_skills: store.skills,
    recentTeamsyncs: store.skills.recentTeamsyncs,
    team: store.skills.team,
    botuser: store.common_reducer.tpuser,
    isWorkspaceAdmin: store.common_reducer.isAdmin,
    userMembership: store.common_reducer.userworkspacemembership,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    // getProfileinfo,
    getWorkspace,
    getUserWorkspaces,
    getBacklogTasks,
    getRecentTeamsyncs,
    recentCheckins,
    logout,
    setCurrentUser,
    checkSlackLink,
    setDriftState,
    getAssisantSkills,
    getWorkspaceMembers,
    getStatuses,
    getTasks,
    getUsersSelectedTeamSync,
    getChannelList,
    resetChannelsList,
    getTrooprBotUser,
  })(sidenavbar2)
);
